import React from 'react'
// import { any } from 'prop-types';
// import {  } from './ApiManager'

const AuthContext = React.createContext({
  isLogged: false,
  username: '',
  login: async (email:string, pwd: string, rememberme: boolean) => await Promise.resolve(),
  logout: () => {},
  user: undefined as any,
  library: undefined as any,
  settings: undefined as any,
  error: undefined as string | undefined,
  // login: login,
})

export const AuthProvider = AuthContext.Provider
export const AuthConsumer = AuthContext.Consumer
export default AuthContext